import icProcess from './assets/icons/ic-card-process.svg';
import icPrint from './assets/icons/ic-card-print.svg';
import icReceive from './assets/icons/ic-card-process.svg';
const PRIVATE = 'http://klg.transjakarta.co.id:8080/api';
const MAIL_SERVICE = 'http://klg.transjakarta.co.id:463/mail-service/';
// const PRIVATE = 'http://localhost:8080/api';

export const LOGIN_URL = `${PRIVATE}/authenticate`
export const GET_STATUS_CATEGORY = `${PRIVATE}/request-statuses`;
export const GET_DOCUMENT = `${PRIVATE}/request-document-download`;

export const PENGAJUAN = `${PRIVATE}/requests`;
export const REJECTION_MAIL = `${MAIL_SERVICE}/reject`;
export const USER_TOKEN = localStorage.getItem('token');

export const FILTER_JENIS_LAYANAN = [
    {name: 'Semua Layanan', value: 'all'},
    {name: 'Kartu Baru', value: 'new'},
    {name: 'Kartu Hilang', value: 'lost'},
    {name: 'Kartu Rusak', value: 'broken'}
];
export const FILTER_INTERVAL_DPK = [
    {name: 'Minggu Ini', value: 'week'},
    {name: 'Bulan Ini', value: 'month'},
    {name: 'Tahun Ini', value: 'year'}
];
export const FILTER_INTERVAL = [
    {name: 'Kapan Saja', value: '-'},
    {name: 'Hari Ini', value: 'today'},
    {name: 'Minggu Ini', value: 'week'},
    {name: 'Bulan Ini', value: 'month'},
    {name: 'Tahun Ini', value: 'year'}
];
export const FILTER_JENIS_PENGGUNA_LAYANAN = [
    {
        name: 'Semua Pengguna',
        value: 'all'
    },
    {
        name: 'Lansia',
        value: 'lansia'
    },
    {
        name: 'Disabilitas',
        value: 'disabilitas'
    },
    {
        name: 'Veteran',
        value: 'veteran'
    },
    {
        name: 'Raskin',
        value: 'raskin'
    },
    {
        name: 'Kepulauan Seribu',
        value: 'kepulauanseribu'
    },
    {
        name: 'Pengurus Masjid',
        value: 'marbot'
    },
    {
        name: 'Paud',
        value: 'paud'
    },
    {
        name: 'Jumantik',
        value: 'jumantik'
    }
];
export const FILTER_STATUS = [
    {name: 'Semua Status', value: 'ALL'},
    {name: 'Diproses', value: 'REQUEST_CREATED'},
    {name: 'Dicetak', value: 'CARD_IS_READY'},
    {name: 'Diterima', value: 'CARD_TAKE_BY_USER'},
];

export const FILTER_STATUS_SLK = [
    {name: 'Diproses', value: 'REQUEST_CREATED', icon: icProcess},
    {name: 'Dicetak', value: 'CARD_IS_READY', icon: icPrint},
    {name: 'Diterima', value: 'CARD_TAKE_BY_USER', icon: icReceive},
];
